<template>
  <div class="billMain">
    <div class="billDetails" :style="{ 'width' : (billingScheduleShow ? '60%' : '100%')}">
      <InputQuery :isDisabled="viewMode" placeholder="Billing Customer Code" :isRequired="true" ref="cu_billcustcode" :items="data.CustCodeData" itemKey="Customer Code" descKey="Customer Name" :selectedObject.sync="data.selectedCustCode" />
      <InputQuery :isDisabled="viewMode" placeholder="Payment Type" :items="data.DefaultPayTypeData" itemKey="Payment Type" descKey="Description" :selectedObject.sync="data.selectedDefaultPayType" />
      <Input :isDisabled="viewMode" placeholder="Bill Term" :inputValue.sync="data.BillingTerm" />
      <InputQuery :isDisabled="viewMode" placeholder="Bill Type" :items="data.BillingTypeData" itemKey="BillType" descKey="Description" :selectedObject.sync="data.selectedBillingType" />
      <InputQuery :isDisabled="viewMode" placeholder="Bill Format" :items="data.BillingFmtData" itemKey="Billing Fmt" descKey="Description" :selectedObject.sync="data.selectedBillingFmt" />
      <InputQuery :isDisabled="viewMode" placeholder="Default Currency" :items="data.DefaultCurData" itemKey="Currency Code" descKey="Description" :selectedObject.sync="data.selectedDefaultCur" />
      <InputQuery :isDisabled="viewMode" placeholder="GL Acc Code" :isRequired="true" ref="cu_glacccode" :items="data.Cu_GLAccData" itemKey="Acc No" descKey="Description" :selectedObject.sync="data.selectedCu_GLAcc" />
      <div class="checkboxBox">
        <Checkbox :isDisabled="viewMode" title="Print Price on CDA" :isChecked.sync="data.CDAPrintPrice" />
      </div>
      <InputQuery :isDisabled="viewMode" placeholder="Internal" :items="data.InternalCustData" itemKey="InternalCustType" descKey="Description" :selectedObject.sync="data.selectedInternalCust" />
      <InputQuery :isDisabled="viewMode" placeholder="Depot Storage Bill" :items="data.DepotStorageBillTypeData" itemKey="DepotStorageBillType" descKey="Description" :selectedObject.sync="data.selectedDepotStorageBillType" />
      <div class="rowBox"><Input :isDisabled="viewMode" class="shortInput" placeholder="Trailer Detention" :inputValue.sync="data.TrDetFreeDaysOrHrs" /> Free Days</div>
      <div class="rowBox"><Input :isDisabled="viewMode" class="shortInput" placeholder="Trailer Staging" :inputValue.sync="data.TrkStgFreeDaysOrHrs" /> Free Days</div>
      <div class="rowBox">
        <Input class="shortInput" style="width: 60%;" placeholder="Billing Schedule" isDisabled="true" :inputValue.sync="billingSchedule" />
        <button @click="buttonClick('changeschedule')" v-if="!viewMode">Change Billing Schedule</button>
      </div>
      <InputQuery :isDisabled="viewMode" placeholder="Invoice Option" :items="data.abInvoiceOptionData" itemKey="InvoiceOption" descKey="Description" :selectedObject.sync="data.selectedabInvoiceOption" />
    </div>

    <div class="scheduleDetails">
      <div class="buttonBox" style="justify-content: flex-end;">
        <button @click="buttonClick('save')">Save</button>
        <button @click="buttonClick('cancel')" style="margin-left: 5px;">Cancel</button>
      </div>
      <div class="scheduleBox" :style="{ 'border-color' : (billingScheduleSelection.None ? 'gray' : 'lightgray'), 'color' : (billingScheduleSelection.None   ? 'black' : 'lightgray') }">
        <Checkbox class="scheduleTitle" title="None" :isChecked.sync="billingScheduleSelection.None" @checkBoxClicked="checkBoxClicked('None')" />
        No billing is done.
      </div>
      <div class="scheduleBox" :style="{ 'border-color' : (billingScheduleSelection.Daily ? 'gray' : 'lightgray'), 'color' : (billingScheduleSelection.Daily   ? 'black' : 'lightgray') }">
        <Checkbox class="scheduleTitle" title="Daily" :isChecked.sync="billingScheduleSelection.Daily" @checkBoxClicked="checkBoxClicked('Daily')" />
        Billing will be done Daily.
      </div>
      <div class="scheduleBox" :style="{ 'border-color' : (billingScheduleSelection.Weekly ? 'gray' : 'lightgray'), 'color' : (billingScheduleSelection.Weekly   ? 'black' : 'lightgray') }">
        <Checkbox class="scheduleTitle" title="Weekly" :isChecked.sync="billingScheduleSelection.Weekly" @checkBoxClicked="checkBoxClicked('Weekly')" />
        <div class="weeklyBox" :style="{ 'color' : (billingScheduleSelection.Weekly ? 'black' : 'lightgray') }">
          <Checkbox title="Mon" :isChecked.sync="billingScheduleData.Weekly.Days.Mon" :isDisabled="!billingScheduleSelection.Weekly" @checkBoxClicked="weeklyCheckbox" />
          <Checkbox title="Tue" :isChecked.sync="billingScheduleData.Weekly.Days.Tue" :isDisabled="!billingScheduleSelection.Weekly" @checkBoxClicked="weeklyCheckbox" />
          <Checkbox title="Wed" :isChecked.sync="billingScheduleData.Weekly.Days.Wed" :isDisabled="!billingScheduleSelection.Weekly" @checkBoxClicked="weeklyCheckbox" />
          <Checkbox title="Thu" :isChecked.sync="billingScheduleData.Weekly.Days.Thu" :isDisabled="!billingScheduleSelection.Weekly" @checkBoxClicked="weeklyCheckbox" />
          <Checkbox title="Fri" :isChecked.sync="billingScheduleData.Weekly.Days.Fri" :isDisabled="!billingScheduleSelection.Weekly" @checkBoxClicked="weeklyCheckbox" />
          <Checkbox title="Sat" :isChecked.sync="billingScheduleData.Weekly.Days.Sat" :isDisabled="!billingScheduleSelection.Weekly" @checkBoxClicked="weeklyCheckbox" />
          <Checkbox title="Sun" :isChecked.sync="billingScheduleData.Weekly.Days.Sun" :isDisabled="!billingScheduleSelection.Weekly" @checkBoxClicked="weeklyCheckbox" />
        </div>
        <Input class="shortInput" style="width: 50%; margin-top: 12px;" placeholder="Days Selected" :inputValue.sync="billingScheduleData.Weekly.selectedDays" isDisabled="true" isRequired="true" :errorMessage.sync="billingScheduleErrors.weeklyError" />
      </div>
      <div class="scheduleBox" :style="{ 'border-color' : (billingScheduleSelection.Monthly ? 'gray' : 'lightgray'), 'color' : (billingScheduleSelection.Monthly   ? 'black' : 'lightgray') }">
        <Checkbox class="scheduleTitle" title="Monthly" :isChecked.sync="billingScheduleSelection.Monthly" @checkBoxClicked="checkBoxClicked('Monthly')" />
        <div :style="{ 'color' : (billingScheduleSelection.Monthly ? 'black' : 'lightgray') }">
          Billing will be done every {{(billingScheduleData.Monthly.selectedDay1) ? billingScheduleData.Monthly.selectedDay1.CodeValue : 'DAY1' }} and {{(billingScheduleData.Monthly.selectedDay2) ? billingScheduleData.Monthly.selectedDay2.CodeValue : 'DAY2' }} of the month.
        </div>
        <Dropdown class="shortInput" style="width: 50%;" placeholder="DAY1" :items.sync="billingScheduleData.Monthly.day1Data" :isDisabled="!billingScheduleSelection.Monthly" itemKey="CodeValue" :selectedObject.sync="billingScheduleData.Monthly.selectedDay1" isRequired="true" :errorMessage.sync="billingScheduleErrors.day1Error" />
        <Dropdown class="shortInput" style="width: 50%;" placeholder="DAY2" :items.sync="billingScheduleData.Monthly.day2Data" :isDisabled="!billingScheduleSelection.Monthly" itemKey="CodeValue" :selectedObject.sync="billingScheduleData.Monthly.selectedDay2" isRequired="true" :errorMessage.sync="billingScheduleErrors.day2Error" />
        <div class="alertBox" :style="{ 'border-color' : (billingScheduleSelection.Monthly ? '#ff000088' : 'lightgray'), 'color' : (billingScheduleSelection.Monthly ? '#ff0000' : 'lightgray') }">
          <div class="alertTitle">NOTE</div>
          System will not run auto-billing for months where selected days DO NOT exist.
        </div>
      </div>
      <div class="scheduleBox" :style="{ 'border-color' : (billingScheduleSelection.Quarterly ? 'gray' : 'lightgray'), 'color' : (billingScheduleSelection.Quarterly   ? 'black' : 'lightgray') }">
        <Checkbox class="scheduleTitle" title="Quarterly" :isChecked.sync="billingScheduleSelection.Quarterly" @checkBoxClicked="checkBoxClicked('Quarterly')" />
        <div :style="{ 'color' : (billingScheduleSelection.Quarterly? 'black' : 'lightgray') }">
          Every month #{{(billingScheduleData.Quarterly.selectedMonth) ? billingScheduleData.Quarterly.selectedMonth.CodeValue : 'MONTH' }} of each quarter, on day #{{(billingScheduleData.Quarterly.selectedDay) ? billingScheduleData.Quarterly.selectedDay.CodeValue : 'DAY'}} of the month.
        </div>
        <Dropdown class="shortInput" placeholder="MONTH" :items.sync="billingScheduleData.Quarterly.monthData" :isDisabled="!billingScheduleSelection.Quarterly" itemKey="CodeValue" :selectedObject.sync="billingScheduleData.Quarterly.selectedMonth" isRequired="true" :errorMessage.sync="billingScheduleErrors.monthError" />
        <Dropdown class="shortInput" placeholder="DAY" :items.sync="billingScheduleData.Quarterly.dayData" :isDisabled="!billingScheduleSelection.Quarterly" itemKey="CodeValue" :selectedObject.sync="billingScheduleData.Quarterly.selectedDay" isRequired="true" :errorMessage.sync="billingScheduleErrors.dayError" />
        <div class="alertBox" :style="{ 'border-color' : (billingScheduleSelection.Quarterly ? '#ff000088' : 'lightgray'), 'color' : (billingScheduleSelection.Quarterly   ? '#ff0000' : 'lightgray') }">
          <div class="alertTitle">NOTE</div>
          System will not run auto-billing for months where selected days DO NOT exist.
        </div>
      </div>
    </div>
    </div>
</template>

<script>
/* eslint-disable */
import Input from '@/components/Input.vue';
import InputQuery from '@/components/InputQuery.vue';
import Dropdown from '@/components/Dropdown.vue';
import Checkbox from '@/components/CheckBox.vue';

export default {
  components: {
    Input, InputQuery, Dropdown, Checkbox
  },
  data: function() {
    return {
    }
  },
  props: {
    viewMode: { type: Boolean, default: false },
    data: { type: Object, default: function () { return {} } },
    billingScheduleShow: { type: Boolean, default: false },
    billingSchedule: { type: String, default: '' },//abBillingCategory
    billingScheduleSelection: {
      type: Object, default: function () {
        return {
          None: true,
          Daily: false,
          Weekly: false,
          Monthly: false,
          Quarterly: false,
        }
      }
    },
    billingScheduleData: {
      type: Object, default: function () {
        return {

          Weekly: {
            Days: {
              Mon: false,
              Tue: false,
              Wed: false,
              Thu: false,
              Fri: false,
              Sat: false,
              Sun: false,
            },
            selectedDays: '',
          },
          Monthly: {
            selectedDay1: null,
            selectedDay2: null,

            day1Data: [],
            day2Data: [],
          },
          Quarterly: {
            selectedMonth: null,
            selectedDay: null,

            monthData: [],
            dayData: [],
          },

        }
      }
    },
    billingScheduleErrors: {
      type: Object, default: function () {
        return {
          weeklyError: '',
          day1Error: '',
          day2Error: '',
          monthError: '',
          dayError: '',
        }
      }
    },
  },
  mounted() {
    this.$bus.$on('customerSetFocus', this.setFocus);
    if (this.data['abBillingCategory']) { this.updateScheduleDesc(this.data['abBillingCategory']); }
    this.mountData();
  },
  methods: {
    mountData: function () {
      for (var m = 1; m <= 3; m++) { this.billingScheduleData.Quarterly['monthData'].push({ '#': m, 'CodeValue': (m < 10 ? ('0' + String(m)) : String(m)) }); };
      for (var m = 1; m <= 31; m++) {
        this.billingScheduleData.Monthly['day1Data'].push({ '#': m, 'CodeValue': (m < 10 ? ('0' + String(m)) : String(m)) });
        this.billingScheduleData.Monthly['day2Data'].push({ '#': m, 'CodeValue': (m < 10 ? ('0' + String(m)) : String(m)) });
        this.billingScheduleData.Quarterly['dayData'].push({ '#': m, 'CodeValue': (m < 10 ? ('0' + String(m)) : String(m)) });
      };
    },
    checkBoxClicked: function (check) {
      Object.keys(this.billingScheduleSelection).forEach((b) => { this.billingScheduleSelection[b] = (check == b) ? true : false; });
    },
    weeklyCheckbox: function () {
      this.billingScheduleErrors['weeklyError'] = '';
      var checkedText = '';
      Object.keys(this.billingScheduleData.Weekly.Days).forEach((b) => { if (this.billingScheduleData.Weekly.Days[b]) { checkedText += String(b) + ' '; }; });
      this.billingScheduleData.Weekly.selectedDays = !checkedText ? '' : checkedText.trim();
    },
    buttonClick: function (btn) {
      switch (btn) {
        case 'changeschedule':
          //console.log('SCHEDULE ----------------------- SCHEDULE');
          this.billingScheduleShow = true;
          break;
        case 'save':
          //console.log('SAVE ----------------------- SAVE');
          try {
            if (this.billingScheduleSelection['Weekly']) {
              var numChecked = 0;
              Object.keys(this.billingScheduleData.Weekly.Days).forEach((b) => { if (this.billingScheduleData.Weekly.Days[b]) { numChecked += 1; }; });
              if (numChecked <= 0) { this.billingScheduleErrors['weeklyError'] = 'Please select at least ONE Day'; };
            }
            if (this.billingScheduleSelection['Monthly']) {
              var numChecked = 0;
              if (this.billingScheduleData.Monthly['selectedDay1']) { numChecked += 1; }
              if (this.billingScheduleData.Monthly['selectedDay2']) { numChecked += 1; }

              this.billingScheduleErrors['day1Error'] = ''; this.billingScheduleErrors['day2Error'] = '';
              if (numChecked <= 0) { this.billingScheduleErrors['day1Error'] = 'Please have at least ONE day selected'; this.billingScheduleErrors['day2Error'] = 'Please have at least ONE day selected'; };
            }
            if (this.billingScheduleSelection['Quarterly']) {
              if (!this.billingScheduleData.Quarterly['selectedMonth']) { this.billingScheduleErrors['monthError'] = 'Please select a Month'; }
              if (!this.billingScheduleData.Quarterly['selectedDay']) { this.billingScheduleErrors['dayError'] = 'Please select a Day'; }
            }

            var noError = true;
            Object.keys(this.billingScheduleErrors).forEach((b) => { if (this.billingScheduleErrors[b] != '') { noError = false; }; });

            if (noError) {
              if (this.billingScheduleSelection['None']) { this.data['abBillingCategory'] = ''; this.updateScheduleDesc(this.data['abBillingCategory']); }
              if (this.billingScheduleSelection['Daily']) { this.data['abBillingCategory'] = 'D'; this.updateScheduleDesc(this.data['abBillingCategory']); }
              if (this.billingScheduleSelection['Weekly']) {
                var codeText = 'W';
                var codeCounter = 1;
                Object.keys(this.billingScheduleData.Weekly.Days).forEach((b) => { if (this.billingScheduleData.Weekly.Days[b]) { codeText += '0' + String(codeCounter); }; codeCounter += 1; });
                //console.log(!codeText ? '' : codeText.trim());
                this.data['abBillingCategory'] = !codeText ? '' : codeText.trim();
                this.updateScheduleDesc(this.data['abBillingCategory']);
              }
              if (this.billingScheduleSelection['Monthly']) {
                var codeText = 'M';
                if (this.billingScheduleData.Monthly['selectedDay1']) { codeText += this.billingScheduleData.Monthly['selectedDay1'].CodeValue }
                if (this.billingScheduleData.Monthly['selectedDay2']) { codeText += this.billingScheduleData.Monthly['selectedDay2'].CodeValue }
                //console.log(!codeText ? '' : codeText.trim());
                this.data['abBillingCategory'] = !codeText ? '' : codeText.trim();
                this.updateScheduleDesc(this.data['abBillingCategory']);
              }
              if (this.billingScheduleSelection['Quarterly']) {
                var codeText = 'Q';
                if (this.billingScheduleData.Quarterly['selectedMonth']) { codeText += this.billingScheduleData.Quarterly['selectedMonth'].CodeValue }
                if (this.billingScheduleData.Quarterly['selectedDay']) { codeText += this.billingScheduleData.Quarterly['selectedDay'].CodeValue }
                this.data['abBillingCategory'] = !codeText ? '' : codeText.trim();
                this.updateScheduleDesc(this.data['abBillingCategory']);
              }

              this.billingScheduleShow = false;
              this.clearSchdule();
            }
          } catch (e) { console.log(e); };
          break;
        case 'cancel':
          //console.log('CANCEL ----------------------- CANCEL');
          this.billingScheduleShow = false;
          this.clearSchdule();
          break;
      }
    },
    updateScheduleDesc: async function (data) {
      try {
        var desc = await this.$apiCallV2(`/CustomerProfile/GetDetailsMaster?master=billscheduledesc&module=MASTER&recordid=` + data);
        this.billingSchedule = !desc.data ? '' : desc.data['Schedulebillingdesc']['BillScheduleDesc'];
      } catch (e) { console.log(e); };
    },
    clearSchdule: function () {
      //-------- Selections
      this.billingScheduleSelection.Daily = true;
      this.billingScheduleSelection.Weekly = false;
      this.billingScheduleSelection.Monthly = false;
      this.billingScheduleSelection.Quarterly = false;

      //-------- Data
      this.billingScheduleData.Weekly.Days.Mon = false;
      this.billingScheduleData.Weekly.Days.Tue = false;
      this.billingScheduleData.Weekly.Days.Wed = false;
      this.billingScheduleData.Weekly.Days.Thu = false;
      this.billingScheduleData.Weekly.Days.Fri = false;
      this.billingScheduleData.Weekly.Days.Sat = false;
      this.billingScheduleData.Weekly.Days.Sun = false;
      this.billingScheduleData.Weekly.selectedDays = '';

      this.billingScheduleData.Monthly.selectedDay1 = null;
      this.billingScheduleData.Monthly.selectedDay2 = null;

      this.billingScheduleData.Quarterly.selectedMonth = null;
      this.billingScheduleData.Quarterly.selectedDay = null;
    },
    setFocus: function (data) {
      try { this.$refs[data['element']].setFocus(); } catch (e) { this.$bus.$emit('customerPageChange', data['page']); };
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

  .rowBox {
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .radioBoxTitle {
    width: 20%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .checkboxBox {
    margin: 0 0 10px 0;
  }

  .shortInput {
    width: 30%;
    margin: 3px 10px 0 0;
  }

  .buttonBox {
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    padding: 10px 0 0 0;
  }

  .billMain {
    width: 100%;
    height: auto;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  .billDetails {
    height: 100%;
  }

  .scheduleDetails {
    margin: 0 0 0 5px;
    flex: 1;
    overflow-x: hidden;
  }

  .scheduleBox {
    width: 100%;
    min-height: 20px;
    padding: 10px 5px 5px 5px;
    margin: 12px 0 0 0;
    position: relative;
    border: solid 1px gray;
    border-radius: 3px;
  }
  
  .scheduleTitle {
    padding: 0 5px 0 5px;
    position: absolute;
    top: -10px;
    left: 10px;
    background-color: white;
    color: gray;
  }

  .alertBox {
    width: 100%;
    height: auto;
    padding: 8px 10px 5px 10px;
    margin: 10px 0 0 0;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: #ff0000;
    border: solid 1px #ff000088;
    border-radius: 3px;
  }

  .alertTitle {
    padding: 0 5px 0 5px;
    font-weight: bold;
    position: absolute;
    top: -10px;
    left: 10px;
    background-color: white;
  }

  .weeklyBox {
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
</style>